import createIcon from '../../createIcon';

/**
 * @component @name Replay
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNlYyTDcgN0wxMiAxMlY4QzE1LjMxIDggMTggMTAuNjkgMTggMTRDMTggMTcuMzEgMTUuMzEgMjAgMTIgMjBDOC42OSAyMCA2IDE3LjMxIDYgMTRINEM0IDE4LjQyIDcuNTggMjIgMTIgMjJDMTYuNDIgMjIgMjAgMTguNDIgMjAgMTRDMjAgOS41OCAxNi40MiA2IDEyIDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Replay = createIcon('Replay', [
  [
    'path',
    {
      d: 'M12 6V2L7 7L12 12V8C15.31 8 18 10.69 18 14C18 17.31 15.31 20 12 20C8.69 20 6 17.31 6 14H4C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14C20 9.58 16.42 6 12 6Z',
      key: '1wrh7v',
    },
  ],
]);

export default Replay;
